<template>
  <v-container fluid>
      <base-material-card
        color="#ac8a2e"
        icon="mdi-notebook"
        inline
        :title="'Documentaciones de   ' + jugador.fullName"
        class="px-5 py-3"
      >
        <template v-slot:after-title>
          <v-btn
            color="#ac8a2e"
            dark
            icon
            @click.stop="openForm('new', idJugador)"
          >
            <v-icon
              large
              color="#ac8a2e"
            >
              mdi-playlist-plus
            </v-icon>
          </v-btn>
        </template>
        <v-row
          align="end"
          justify="end"
        >
          <v-col
            cols="5"
          >
          </v-col>
        </v-row>
        <v-divider class="mt-3" />
        <v-data-table
          :headers="headers"
          :items="documentaciones"
        >
        <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip content-class="top" left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon left small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
            <v-tooltip content-class="top" top>
              <template v-slot:activator="{ on, attrs }">
                <upload-files
                  style="display:inline-block"
                  icono
                  folder="/documentaciones/jugadores_documentacion"
                  tipo="pdf"
                  :documento-id="item.documentacion.id"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
            </v-tooltip>
        </template>
        </v-data-table>
      </base-material-card>
      <confirm ref="confirm"></confirm>
      <documentaciones-form v-model="showForm" @close-dialog="closeDialog" ref="DocumentacionesForm" />
  </v-container>
</template>

<script>
  import DocumentacionesForm from '../abms/altas/DocumentacionesForm.vue'
  import confirm from '../../components/confirm.vue'
  import UploadFiles from '../../components/base/UploadFiles.vue'

  export default {
    components: {
      DocumentacionesForm,
      confirm,
      UploadFiles,
    },
    props: {
      idJugador: {
        type: Number,
        required: true,
        default: 0,
      },
      public: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data () {
      return {
        showForm: false,
        documentaciones: [],
        headers: [
          { text: 'Documento', align: 'start', sortable: true, value: 'documentacion.nombre' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end', widht: '100px' },
        ],
        ir: '',
        jugador: {},
      }
    },
    created () {
      this.getDocumentos()
      this.getJugador()
    },
    methods: {
      getDocumentos () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/doc/jugador/' + this.idJugador }).then(response => { this.documentaciones = response })
      },
      getJugador: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador/' + this.idJugador }).then(response => { this.jugador = response })
      },
      openForm (mode, idJugador) {
        this.showForm = true
        this.$refs.DocumentacionesForm.getJugadorId(mode, idJugador)
      },
      closeDialog: function () {
        this.getDocumentos()
      },
      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el documento ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },
      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/documentacion/' + item.documentacion.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Documento eliminado'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getDocumentos()
      },
    },
  }
</script>
